import { Component } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  isParaActive = false;
  isBtnActive = false;

  constructor(private translate: TranslateService) {
    translate.setDefaultLang('es');
  }

  toggleClass() {
    this.isParaActive = !this.isParaActive;
    this.isBtnActive = !this.isBtnActive;
}

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts